<template>
  <div class="docs-root">
    <header class="docs-header">
      <router-link :to="{ name: 'panduan' }" class="docs-brand">AccuTrax.id · Panduan</router-link>
      <button type="button" class="docs-menu-btn" @click="menuBuka = !menuBuka">
        <i class="fas fa-bars"></i> Daftar Isi
      </button>
      <!-- Tautan panduan sering dibagikan di grup chat dan dibuka orang yang belum login,
           jadi tombol ini mengantar ke login; yang sudah login langsung ke aplikasi. -->
      <router-link :to="store.isLogin ? '/home' : '/login-form'" class="docs-login">
        <i :class="store.isLogin ? 'fas fa-gauge-high' : 'fas fa-right-to-bracket'"></i>
        {{ store.isLogin ? "Buka Aplikasi" : "Masuk ke Sistem" }}
      </router-link>
    </header>
    <div class="docs-body">
      <nav class="docs-sidebar" :class="{ 'docs-sidebar-open': menuBuka }">
        <div v-for="grup in nav" :key="grup.judul" class="docs-group">
          <div class="docs-group-title">{{ grup.judul }}</div>
          <router-link v-for="item in grup.items" :key="item.name" :to="{ name: item.name }" class="docs-link"
            exact-active-class="docs-link-active" @click="menuBuka = false">
            {{ item.label }}
          </router-link>
        </div>
      </nav>
      <main class="docs-main">
        <slot />
      </main>
    </div>
  </div>
</template>

<script>
import docsNav from "@/docs/docs-nav";
import { useAppStore } from "@/stores/app-store";

export default {
  name: "DocsLayout",
  data() {
    return { nav: docsNav, menuBuka: false, store: useAppStore() };
  },
};
</script>

<style>
/* .app di App.vue adalah flex row: tanpa flex/width panduan menyusut selebar isinya */
.docs-root { flex: 1 1 auto; width: 100%; min-height: 100vh; background: #f8fafc; color: #1e293b; font-size: 15px; }
.docs-header { position: sticky; top: 0; z-index: 10; display: flex; align-items: center; gap: 12px;
  padding: 10px 16px; background: #3b82f6; color: #fff; }
.docs-header a.docs-brand { color: #fff; font-weight: 700; font-size: 17px; text-decoration: none; margin-right: auto; }
.docs-menu-btn { display: none; background: transparent; border: 1px solid #fff8; color: #fff;
  border-radius: 6px; padding: 5px 10px; cursor: pointer; }
.docs-header a.docs-login { color: #1d4ed8; background: #fff; border-radius: 6px; padding: 6px 12px; text-decoration: none;
  font-weight: 600; white-space: nowrap; }
.docs-body { display: flex; max-width: 1200px; margin: 0 auto; }
.docs-sidebar { width: 250px; flex-shrink: 0; padding: 20px 12px; position: sticky; top: 52px;
  align-self: flex-start; }
.docs-group { margin-bottom: 18px; }
.docs-group-title { font-size: 12px; font-weight: 700; text-transform: uppercase; color: #64748b; margin: 0 8px 6px; }
.docs-link { display: block; padding: 6px 8px; border-radius: 6px; color: #334155; text-decoration: none; }
.docs-link:hover { background: #e2e8f0; }
.docs-link-active { background: #dbeafe; color: #1d4ed8; font-weight: 600; }
.docs-main { flex: 1; min-width: 0; padding: 24px 20px 60px; }

.docs-prose { max-width: 820px; line-height: 1.65; }
.docs-prose h1 { font-size: 28px; font-weight: 700; margin: 0 0 8px; }
.docs-prose h2 { scroll-margin-top: 64px; font-size: 21px; font-weight: 700; margin: 34px 0 10px; padding-top: 8px; border-top: 1px solid #e2e8f0; }
.docs-prose h3 { font-size: 17px; font-weight: 700; margin: 20px 0 8px; }
.docs-prose p, .docs-prose ul, .docs-prose ol { margin: 0 0 12px; }
.docs-prose ul { list-style: disc; padding-left: 22px; }
.docs-prose ol { list-style: decimal; padding-left: 22px; }
.docs-prose a { color: #1d4ed8; text-decoration: underline; }
.docs-prose code { background: #e2e8f0; padding: 1px 5px; border-radius: 4px; font-size: 90%; }
.docs-prose table { border-collapse: collapse; margin: 0 0 14px; width: 100%; }
.docs-prose th, .docs-prose td { border: 1px solid #cbd5e1; padding: 6px 10px; text-align: left; }
.docs-prose th { background: #f1f5f9; }
.docs-lead { font-size: 17px; color: #475569; }
.doc-steps { list-style: none !important; padding-left: 0 !important; counter-reset: langkah; }
.doc-step { position: relative; padding-left: 42px; margin-bottom: 16px; counter-increment: langkah; }
.doc-step::before { content: counter(langkah); position: absolute; left: 0; top: 0; width: 28px; height: 28px;
  border-radius: 50%; background: #3b82f6; color: #fff; font-weight: 700; display: flex; align-items: center;
  justify-content: center; font-size: 14px; }
.doc-step-title { font-weight: 700; margin-bottom: 2px; }
.doc-callout { border-left: 4px solid #3b82f6; background: #eff6ff; padding: 10px 14px; border-radius: 6px; margin: 0 0 14px; }
.doc-callout-tip { border-color: #16a34a; background: #f0fdf4; }
.doc-callout-caution { border-color: #d97706; background: #fffbeb; }
.doc-callout-title { font-weight: 700; margin-bottom: 2px; }
.doc-figure { margin: 6px 0 18px; }
.doc-figure img { max-width: 100%; border: 1px solid #cbd5e1; border-radius: 8px; }
.doc-figure figcaption { font-size: 13px; color: #64748b; margin-top: 4px; }
.doc-cards { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 12px; }
.doc-card { display: block; border: 1px solid #cbd5e1; border-radius: 8px; padding: 14px; background: #fff;
  text-decoration: none !important; color: inherit !important; }
.doc-card:hover { border-color: #3b82f6; }
.doc-card-title { font-weight: 700; color: #1d4ed8; margin-bottom: 4px; }

@media (max-width: 800px) {
  .docs-menu-btn { display: inline-block; }
  .docs-body { display: block; }
  .docs-sidebar { display: none; position: static; width: auto; background: #fff; border-bottom: 1px solid #e2e8f0; }
  .docs-sidebar-open { display: block; }
  .docs-main { padding: 18px 16px 48px; }
  .docs-brand { font-size: 15px; }
}
</style>
